// removed by extract-text-webpack-plugin
module.exports = {"subscribe-page":"subscribe-page","subscribe-header":"subscribe-header","button-close-page":"button-close-page","page-title":"page-title","subscribe-content":"subscribe-content","subscribe-title":"subscribe-title","subscribe-description":"subscribe-description"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/subscribe/subscribe.style.sass
// module id = siip
// module chunks = 0